module.exports = __webpack_public_path__ + "img/img9.9c50200e.png";